module.exports = __webpack_public_path__ + "fonts/Inter-400-greek46.8c7f6ae.woff2";